"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = void 0;
exports.utils = {
    breakpoints: {
        phoneMini: "374px",
        phoneSmall: "400px",
        phone: "480px",
        tablet: "768px",
        mobile: "1024px",
        laptop: "1280px",
        desktopSmall: "1440px",
        desktop: "1680px",
        desktopLarge: "1920px"
    },
    radius: "2px",
    radiusLarge: "12px",
    transition: {
        default: "0.3s ease-in-out"
    }
};
//# sourceMappingURL=utils.js.map